import { Button, ButtonVariant } from "@repo/ui/Buttons/button";
import { IconButton } from "@repo/ui/Buttons/iconButton";
import { IconPencil } from "@tabler/icons-react";
import type { FC, ReactNode } from "react";
import { useNavigate } from "react-router";
import { appPaths } from "../../../app/appPaths.js";
import {
  KeywordTrackerCard,
  type KeywordTrackerCardProps,
} from "./keywordTrackerCard.js";

export const KeywordTrackerCardContainer: FC<
  KeywordTrackerCardProps & { questionNumber: number | undefined }
> = (props) => {
  const navigate = useNavigate();
  const { keywordTracker } = props;

  const renderContent = () => {
    if (keywordTracker.keywords.length === 0) {
      return (
        <div className="flex flex-col p-4 text-center text-base text-foreground">
          {`Add keywords like competitor names to track when they appear in interviews.`}
          <div className="mt-4 flex items-center justify-center">
            <Button
              variant={ButtonVariant.Primary}
              onClick={() => {
                navigate(appPaths.settingsKeywordTrackers.build());
              }}
            >
              Add keywords
            </Button>
          </div>
        </div>
      );
    }

    return <KeywordTrackerCard {...props} />;
  };

  const title =
    keywordTracker.type === "competitive"
      ? "Competitive analysis"
      : keywordTracker.name;

  return (
    <InsightsCard
      header={
        <>
          <div className="flex min-h-[28px] flex-row items-center space-x-1 text-base font-semibold text-foreground">
            <div>{title}</div>
            {keywordTracker.type === "competitive" && (
              <div className="hidden group-hover:block">
                <IconButton
                  variant={ButtonVariant.Tertiary}
                  onClick={() => {
                    navigate(appPaths.settingsKeywordTrackers.build());
                  }}
                  icon={<IconPencil className="h-4 w-4 text-gray-600" />}
                />
              </div>
            )}
          </div>
        </>
      }
      body={renderContent()}
    />
  );
};

export const InsightsCard: FC<{ header: ReactNode; body: ReactNode }> = ({
  header,
  body,
}) => {
  return (
    <div className="flex flex-col overflow-hidden rounded-xl border border-border-light">
      <div className="group flex flex-row items-center border-b border-slate-900/5 bg-slate-100 px-3 py-1.5">
        <div className="flex flex-col">{header}</div>
      </div>
      {body}
    </div>
  );
};
